module.exports = __webpack_public_path__ + "img/kanji.884dba9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kanji.png
// module id = rhR+
// module chunks = 1